import React, {
  FocusEvent,
  forwardRef,
} from 'react';
import clsx from 'clsx';
import MaskedTextField from 'components/common/MaskedTextField';
import UnitedStateIcon from 'assets/svg/UnitedStateIcon';

const defaultMask = [{
  mask: '+{1} (000) 000-0000',
  lazy: true,
  overwrite: true,
}];

type Props = {
  id?: string;
  disabled?: boolean;
  value?: string | null;
  onChange: (value: string | number | null) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  className?: string;
  containerClassName?: string;
  inputProps?: object;
  error?: boolean;
  mask?: Record<string, any> | Record<string, any>[],
  autoFocus?: boolean;
  sx?: any;
  size?: 'small' | 'medium';
}

const PhoneInput = forwardRef<HTMLInputElement, Props>(({
  value,
  className,
  containerClassName,
  onChange,
  onFocus,
  error,
  mask,
  sx,
  size = 'small',
  ...props
}, ref) => {
  const classes = clsx('flex items-center w-full bg-[#f5f5f5] border rounded', containerClassName, { 'border-red-500': error });
  return (
    <div className={classes}>
      <div className="px-2 py-1.5">
        <UnitedStateIcon />
      </div>
      <MaskedTextField
        {...props}
        inputRef={ref}
        unmask
        mask={mask ?? defaultMask}
        cursorPositionOnFocus="phoneNumber"
        selectOnPointerFocus
        maskedPosition={{ start: 3, end: 0 }}
        value={value ?? ''}
        onAccept={onChange}
        className={clsx('populate-phone-input bg-white', className)}
        sx={sx}
        size={size}
      />
    </div>

  );
});

PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
